module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_vm._v(_vm._s(_vm.common.serv.get(_vm.code).servName))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62c787be","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ServTag/index.vue
// module id = 653
// module chunks = 0